import React, { useEffect } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import './Membership360.css';
import {
  MONTH_GET,
  MONTH_JOURNEY,
  SCARCITY,
  getOrbitPage,
  whatsappHref,
} from './orbitContent';
import OrbitFaq from './OrbitFaq';
import OrbitInterestForm from './OrbitInterestForm';

function CtaWhatsApp({ className, children }) {
  return (
    <a
      className={className}
      href={whatsappHref()}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
}

function OfferLayout({ page, slug }) {
  const others = MONTH_GET.filter((m) => m.to !== `/orbit/${slug}`);

  return (
    <>
      <header
        className="od-hero"
        style={{ '--od-accent': page.accent }}
      >
        <div className="m360-wrap">
          <p className="od-emoji" aria-hidden="true">
            {page.icon}
          </p>
          <h1>{page.title}</h1>
          <p className="od-line">{page.line}</p>
        </div>
      </header>

      <section className="od-block" data-reveal>
        <div className="m360-wrap">
          <h2>In the box</h2>
          <div className="od-chips">
            {page.inBox.map((item) => (
              <span key={item.label} className="od-chip">
                <span className="od-ico" aria-hidden="true">
                  {item.icon}
                </span>
                <span className="od-chip-text">{item.label}</span>
              </span>
            ))}
          </div>
        </div>
      </section>

      <section className="od-band" style={{ '--od-accent': page.accent }} data-reveal>
        <div className="m360-wrap">
          <h2>Looks like</h2>
          <ol className="od-looks">
            {page.looksLike.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ol>
        </div>
      </section>

      <section className="od-block" data-reveal>
        <div className="m360-wrap od-duo">
          <p>
            <strong>You</strong>
            <span>{page.you}</span>
          </p>
          <p>
            <strong>They</strong>
            <span>{page.they}</span>
          </p>
        </div>
      </section>

      <section className="od-block od-block-tight">
        <div className="m360-wrap">
          <div className="od-not">
            {page.not.map((n) => (
              <span key={n}>{n}</span>
            ))}
          </div>
        </div>
      </section>

      <section className="od-block">
        <div className="m360-wrap od-actions">
          <Link className="m360-btn m360-btn-primary" to="/orbit/join#interest">
            {SCARCITY.cta}
          </Link>
          <CtaWhatsApp className="m360-btn m360-btn-ghost">WhatsApp</CtaWhatsApp>
          {page.next && (
            <Link
              className="od-next"
              to={page.next.to}
              style={{ '--od-accent': page.accent }}
            >
              Next: {page.next.label} →
            </Link>
          )}
        </div>
      </section>

      {others.length > 0 && (
        <section className="od-block od-more">
          <div className="m360-wrap">
            <p className="od-more-label">Also this month</p>
            <div className="od-more-row">
              {others.map((m) => (
                <Link key={m.to} to={m.to}>
                  <span className="od-ico" aria-hidden="true">
                    {m.icon}
                  </span>
                  <span className="od-chip-text">{m.title}</span>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
}

function MapLayout({ page }) {
  return (
    <>
      <header className="od-hero">
        <div className="m360-wrap">
          <p className="od-emoji" aria-hidden="true">
            {page.icon}
          </p>
          <h1>{page.title}</h1>
          <p className="od-line">{page.line}</p>
        </div>
      </header>

      <section className="od-block" data-reveal>
        <div className="m360-wrap">
          <h2>The whole month</h2>
          <div className="od-journey">
            {MONTH_JOURNEY.map((step) => (
              <article key={step.title}>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="od-band" style={{ '--od-accent': page.accent }} data-reveal>
        <div className="m360-wrap">
          <h2>Starting rhythm — tap to open</h2>
          <p className="od-band-note">Tap a piece for the full unpack.</p>
          <div className="od-map">
            {MONTH_GET.map((m, i) => (
              <Link
                key={m.to}
                to={m.to}
                className="od-map-tile"
                style={{ '--od-i': i }}
              >
                <span className="od-ico" aria-hidden="true">
                  {m.icon}
                </span>
                <span className="od-map-copy">
                  <strong>{m.title}</strong>
                  <em>{m.text}</em>
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="od-block">
        <div className="m360-wrap od-actions">
          <Link className="m360-btn m360-btn-primary" to="/orbit/join#interest">
            {SCARCITY.cta}
          </Link>
          <Link className="m360-btn m360-btn-ghost" to="/orbit/faq">
            Read FAQ
          </Link>
        </div>
      </section>
    </>
  );
}

function MissionLayout({ page }) {
  return (
    <>
      <header className="od-hero">
        <div className="m360-wrap">
          <p className="od-emoji" aria-hidden="true">
            {page.icon}
          </p>
          <h1>{page.title}</h1>
          <p className="od-line">{page.line}</p>
        </div>
      </header>
      <section className="od-split">
        <div className="od-split-panel od-split-mission">
          <h2>Mission</h2>
          <p>{page.mission}</p>
        </div>
        <div className="od-split-panel od-split-vision">
          <h2>Vision</h2>
          <p>{page.vision}</p>
        </div>
      </section>
      <section className="od-block">
        <div className="m360-wrap od-actions">
          <Link className="m360-btn m360-btn-primary" to="/orbit/join#interest">
            {SCARCITY.cta}
          </Link>
          <Link className="m360-btn m360-btn-ghost" to={page.next.to}>
            {page.next.label} →
          </Link>
        </div>
      </section>
    </>
  );
}

function JoinLayout({ page }) {
  return (
    <>
      <header className="od-hero" style={{ '--od-accent': page.accent }}>
        <div className="m360-wrap">
          <p className="od-emoji" aria-hidden="true">
            {page.icon}
          </p>
          <h1>{page.title}</h1>
          <p className="od-line">{page.line}</p>
          {page.next?.to && (
            <p className="od-band-note" style={{ marginTop: '0.75rem' }}>
              <Link to={page.next.to}>{page.next.label} →</Link>
            </p>
          )}
        </div>
      </header>
      <section className="od-block" data-reveal>
        <div className="m360-wrap">
          <h2>How it starts</h2>
          <ol className="od-steps">
            {page.steps.map((s, i) => (
              <li key={s}>
                <span>{i + 1}</span>
                {s}
              </li>
            ))}
          </ol>
        </div>
      </section>
      <section className="od-block" data-reveal>
        <div className="m360-wrap" style={{ width: '100%' }}>
          <OrbitInterestForm />
        </div>
      </section>
    </>
  );
}

function FaqLayout({ page }) {
  return (
    <>
      <header className="od-hero">
        <div className="m360-wrap">
          <p className="od-emoji" aria-hidden="true">
            {page.icon}
          </p>
          <h1>{page.title}</h1>
          <p className="od-line">{page.line}</p>
        </div>
      </header>
      <section className="od-block">
        <div className="m360-wrap" style={{ width: '100%' }}>
          <OrbitFaq />
        </div>
      </section>
      <section className="od-block">
        <div className="m360-wrap od-actions">
          <Link className="m360-btn m360-btn-primary" to="/orbit/join#interest">
            {SCARCITY.cta}
          </Link>
          <Link className="m360-btn m360-btn-ghost" to="/orbit/what-you-get">
            See what you get →
          </Link>
        </div>
      </section>
    </>
  );
}

const OrbitDetailPage = () => {
  const { slug } = useParams();
  const page = getOrbitPage(slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!page) {
    return <Navigate to="/orbit/what-you-get" replace />;
  }

  return (
    <main className="m360 od" style={{ '--od-accent': page.accent }}>
      {page.layout === 'offer' && <OfferLayout page={page} slug={slug} />}
      {page.layout === 'map' && <MapLayout page={page} />}
      {page.layout === 'mission' && <MissionLayout page={page} />}
      {page.layout === 'join' && <JoinLayout page={page} />}
      {page.layout === 'faq' && <FaqLayout page={page} />}
    </main>
  );
};

export default OrbitDetailPage;
